import { Outlet, useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { MessageCircle, Star } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import FloatingSocials from "@/components/FloatingSocials";
import BookingPopup from "@/components/BookingPopup";

export default function PublicLayout() {
  const [bookingOpen,setBookingOpen] = useState(false);
  const location = useLocation();
  useEffect(()=>{
    const shown = localStorage.getItem("wt-booking-popup-shown");
    if(shown) return;
    const timer = setTimeout(()=>{
      setBookingOpen(true);
      localStorage.setItem("wt-booking-popup-shown","1");
    },1500);
    return()=>clearTimeout(timer);
  },[location.pathname]);
  return <div className="public-site min-h-screen">
    <PublicHeader onBook={()=>setBookingOpen(true)} />
    <main className="pt-20"><Outlet /></main>
    <PublicFooter />
    <FloatingSocials onBook={()=>setBookingOpen(true)}/>
    <div className="sticky-action-icons" aria-label="Quick actions">
      <Link className="sticky-action sticky-review" to="/review" aria-label="Give Wedding Touch a review" title="Give a review"><Star size={23} fill="currentColor"/></Link>
      <a className="sticky-action sticky-whatsapp" href="https://wa.me/919933420292" target="_blank" rel="noreferrer" aria-label="Chat with Wedding Touch on WhatsApp" title="WhatsApp"><MessageCircle size={22}/></a>
    </div>
    <button className="floating-book" onClick={()=>setBookingOpen(true)}>Book your date</button>
    <BookingPopup open={bookingOpen} onClose={()=>setBookingOpen(false)}/>
  </div>;
}
